/*
 * Wygląd paginacji HeroUI w tabelach panelu (jak na dashboardzie): kafelki 32 px z ramką
 * border-default i r/8, bez tła i cienia; aktywna strona accent-ink z białą cyfrą.
 * Telefon: kafelki 36 px (większe, a 9 pozycji mieści się w szerokości ekranu), na środku.
 */
const PAGINATION_ITEM_CLASS = [
  'min-w-8 w-8 h-8 rounded-8 border border-border-default bg-transparent shadow-none',
  'max-sm:min-w-9 max-sm:w-9 max-sm:h-9 max-sm:text-medium',
  'text-small font-medium text-text-secondary',
  'data-[hover=true]:bg-transparent data-[hover=true]:border-border-strong data-[hover=true]:text-text-primary',
  'dark:text-gray-300',
].join(' ');

export const PAGINATION_CLASS_NAMES = {
  base: 'max-sm:mx-auto',
  wrapper: 'gap-1 overflow-visible h-8 shadow-none max-sm:h-9 max-sm:gap-0.5',
  item: PAGINATION_ITEM_CLASS,
  cursor: [
    'min-w-8 w-8 h-8 rounded-8 bg-accent-ink text-white font-semibold shadow-none',
    'max-sm:min-w-9 max-sm:w-9 max-sm:h-9 max-sm:text-medium',
  ].join(' '),
  prev: `${PAGINATION_ITEM_CLASS} data-[disabled=true]:opacity-40`,
  next: `${PAGINATION_ITEM_CLASS} data-[disabled=true]:opacity-40`,
};

/* Kontener paginacji pod tabelą: do prawej (na telefonie na środku), z linią nad nią. */
export const PAGINATION_BAR_CLASS = 'flex justify-end max-sm:justify-center border-t border-border-default pb-2 pt-4';
